import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

const PRICE_PER_HOUR_TYPE_LABELS = {
    WELDING: "Soldadura",
};

export const translatePricePerHourType = (type) => PRICE_PER_HOUR_TYPE_LABELS[type] || type;

export const getAllPricesPerHour = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.PRICE_PER_HOUR}`, {
        params: { page, size, search: searchString },
    });
    return response.data;
};

export const updatePricePerHour = async (id, pricePerHour) => {
    const response = await api.put(`/${ENDPOINTS.PRICE_PER_HOUR}/${id}`, pricePerHour);
    return response.data;
};